export default function SubjectsTitle(){

    return(
        <div className="subjects-title">
            <h1 className='subjects-menu-title'>S<span>cience</span> & M<span>athematics</span> W<span>ebsite</span></h1>
            <h3 className="subjects-menu-title-addition">Discover new things on:</h3>
        </div>
    ) 
}